import { useEffect, useState } from "react";
import { fetchExpenseFile } from "../../api/expenses";

// Full-screen look at a receipt or statement. Files need sign-in, so they're
// fetched with the token and shown from memory rather than linked directly.
export default function FileViewer({ file, onClose }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let made = null;
    fetchExpenseFile(file.id)
      .then((blob) => {
        made = URL.createObjectURL(blob);
        setUrl(made);
      })
      .catch((e) => setError(e.message || "Couldn't open it."));
    return () => made && URL.revokeObjectURL(made);
  }, [file.id]);

  const isImage = (file.content_type || "").startsWith("image/");
  return (
    <div className="fixed inset-0 z-[60] bg-black/85 flex flex-col" onClick={onClose}>
      <div className="flex items-center justify-between p-3 text-white text-sm">
        <span className="truncate">{file.filename}</span>
        <button type="button" className="font-semibold px-2">
          Close
        </button>
      </div>
      <div className="flex-1 overflow-auto flex items-center justify-center p-3">
        {error ? (
          <p className="text-white text-sm">{error}</p>
        ) : !url ? (
          <p className="text-white/70 text-sm">Opening…</p>
        ) : isImage ? (
          <img src={url} alt={file.filename} className="max-w-full max-h-full" />
        ) : (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="rounded-xl bg-white px-5 py-3 font-semibold text-birdie-green"
          >
            Open the PDF
          </a>
        )}
      </div>
    </div>
  );
}
